import React from "react";
import { Container, StyledMainContainer } from "../Layout/styles";
import { Button, Typography } from "@mui/material";
import {
  StyledLandingButtons,
  StyledLandingHeader,
  StyledLandingPage,
} from "./styles";
import { FcNext } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { selectUserLoginState } from "../../config/redux/slices/userSlice/selectors";
import { useSelector } from "react-redux";
import AskNotifications from "../../components/AskNotifications";

const LandingPage = () => {
  const navigate = useNavigate();
  const isUserLoggedIn = useSelector(selectUserLoginState);

  const onContinueClick = () => {
    navigate(isUserLoggedIn ? "/app/" : "/login");
  };
  return (
    <Container>
      <StyledMainContainer>
        <StyledLandingPage>
          <StyledLandingHeader>
            <Typography variant="h3" color="teal" fontWeight="bold">
              Welcome to Psyming
            </Typography>
            <Typography variant="body1">Daily Tracker App</Typography>
          </StyledLandingHeader>
          <StyledLandingButtons>
            <Button
              variant="outlined"
              color="primary"
              endIcon={<FcNext />}
              onClick={onContinueClick}
            >
              {isUserLoggedIn ? "Continue to App" : "Login"}
            </Button>
            {isUserLoggedIn && <AskNotifications />}
          </StyledLandingButtons>
        </StyledLandingPage>
      </StyledMainContainer>
    </Container>
  );
};

export default LandingPage;
